import Api from '../api';

const featureFlagEndpoint = '/feature-flag';

const FeatureFlagAPI = {
  async getFeatureFlags() {
    const url = `${featureFlagEndpoint}`;
    return Api.get(url);
  },
};

export default FeatureFlagAPI;
